import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AuthService } from './auth.service';
import { isCredentialError } from './credential-error';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(private router: Router, private _auth: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (this._auth.isLoggedIn()) {
      //Requisições Externas
      const hostnameDefault = environment.endpoint().split('//')[1].split('/')[0];
      const hostnameRequest = request.url.includes('//') ? request.url.split('//')[1].split('/')[0] : request.url;

        //Manipular Cabeçalho apenas de requisições do Hellius
      if (hostnameDefault == hostnameRequest) {
        if (request.headers.get('FormData') == 'true') {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this._auth.getJwtToken()}`,
            },
          });
        } else {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${this._auth.getJwtToken()}`,
              'Content-Type': 'application/json',
            },
          });
        }
      }
    }

    return next.handle(request).pipe(
      tap(
        () => { },
        (err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (err.status !== 401) {
              return;
            }
            // 401 de CREDENCIAL (senha atual incorreta na troca de senha) não é
            // sessão expirada: a sessão é preservada e o erro é tratado no campo
            // pelo componente. É restrição do gatilho de deslogue, nunca
            // ampliação — todo 401 que não case A+B continua deslogando.
            if (isCredentialError(err.url, err.error?.message)) {
              return;
            }
            this.router.navigate(['login']);
          }
        },
      ),
    );
  }
}
